import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Switch,
  FormControlLabel,
  MenuItem,
  Box,
  FormControl,
  InputLabel,
  Select
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import couponService from '../service/couponService'; 
import { getCurrencies } from '../service/commonService';

const CouponManager = () => {
  const [coupons, setCoupons] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingCoupon, setEditingCoupon] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [formData, setFormData] = useState({
    couponId: null,
    code: "",
    description: "",
    discountType: "PERCENTAGE", // default
    scope: "CART",
    discountValue: 0,
    maxDiscountAmount: 0,
    minOrderAmount: 0,
    currencyId: "",
    startDate: "",
    endDate: "",
    usageLimit: 1,
    usedCount: 0,
    isActive: true,
    perUserLimit: 0,
  });

  // ✅ Fetch coupons on mount 
  useEffect(() => {
    fetchCoupons();
       loadData();
  }, []);

    const loadData = async () => {
          const currencyRes = await getCurrencies();
    setCurrencies(currencyRes.data.content);
    };
  
  const fetchCoupons = async () => {
    try {
      const res = await couponService.fetchCoupon(); //axios.get("/api/coupons");
      setCoupons(res);
      console.log("res coup: ", res);
    } catch (err) {
      console.error("Error fetching coupons", err);
    }
  };

  // ✅ Open dialog for add/edit
  const handleOpen = (coupon = null) => {
    if (coupon) {
      setEditingCoupon(coupon);
      setFormData(coupon);
    } else {
      setEditingCoupon(null);
      setFormData({
        couponId: null,
        code: "",
        description: "",
        discountType: "PERCENTAGE",
         scope: "CART",
        discountValue: 0,
        maxDiscountAmount: 0,
        minOrderAmount: 0,
        currencyId: "",
        startDate: "",
        endDate: "",
        usageLimit: 1,
        usedCount: 0,
        isActive: true,
        perUserLimit: 0,
      });
    }
    setOpen(true);
  };

  // ✅ Save coupon (add or update)
  const handleSave = async () => {
    try { 
   if (
    !formData.code ||
    !formData.description ||
    !formData.discountType ||
    !formData.discountValue ||
    !formData.maxDiscountAmount ||
    !formData.minOrderAmount ||
    !formData.currencyId ||
    !formData.startDate ||
    !formData.endDate ||
    !formData.usageLimit ||
     !formData.scope ||
     !formData.perUserLimit 
  ) {
    alert("Please fill in all required fields.");
    return;
  }
      
      if (editingCoupon) {
        await couponService.updateCoupon(formData.couponId,formData);//  axios.put(`/api/coupons/${formData.couponId}`, formData);
      } else {
        await couponService.saveCoupon(formData); //axios.post("/api/coupons", formData);
      }
      fetchCoupons();
      setOpen(false);
    } catch (err) {
      console.error("Error saving coupon", err);
    }
  };

  // ✅ Delete coupon
  const handleDelete = async (id) => {
     if (window.confirm("Are you sure you want to delete this coupon?")) {
    try {
      await couponService.deleteCoupon(id); //axios.delete(`/api/coupons/${id}`);
      fetchCoupons();
    } catch (err) {
      console.error("Error deleting coupon", err);
    }
     }
  };

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ✅ DataGrid columns
  const columns = [
    { field: "code", headerName: "Code", flex: 1 },
    { field: "description", headerName: "Description", flex: 1 },
    { field: "discountType", headerName: "Type", flex: 1 },
    { field: "discountValue", headerName: "Value", flex: 1 },
    { field: "maxDiscountAmount", headerName: "Max Discount", flex: 1 },
    { field: "minOrderAmount", headerName: "Min Order", flex: 1 },
    { field: "currencyId", headerName: "Currency", flex: 1 },
    { field: "startDate", headerName: "Start Date", flex: 1 },
    { field: "endDate", headerName: "End Date", flex: 1 },
    { field: "usageLimit", headerName: "Usage Limit", flex: 1 },
    { field: "usedCount", headerName: "Used Count", flex: 1 },
    {
      field: "isActive",
      headerName: "Active",
      flex: 1,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <>
          <Button size="small" onClick={() => handleOpen(params.row)}>
            Edit
          </Button>
          <Button
            size="small"
            color="error"
            onClick={() => handleDelete(params.row.couponId)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box p={2}>
      <h2>Coupon Management</h2>
      <Button variant="contained" onClick={() => handleOpen()}>
        Add Coupon
      </Button>

      <Box mt={2} style={{ height: 500 }}>
        <DataGrid
          rows={coupons}
          columns={columns}
          getRowId={(row) => row.couponId}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </Box>

      {/* Dialog for Add/Edit */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editingCoupon ? "Edit Coupon" : "Add Coupon"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Code"
            name="code"
            fullWidth
            value={formData.code}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Description"
            name="description"
            fullWidth
            value={formData.description}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Scope"
            name="scope"
            select
            fullWidth
            value={formData.scope}
            onChange={handleChange}
            required
          >
            <MenuItem value="CART">Cart</MenuItem>
            <MenuItem value="PRODUCT">Product</MenuItem>
          </TextField>
          <TextField
            margin="dense"
            label="Discount Type"
            name="discountType"
            select
            fullWidth
            value={formData.discountType}
            onChange={handleChange}
            required
          >
            <MenuItem value="PERCENTAGE">Percentage</MenuItem>
            <MenuItem value="FIXED_AMOUNT">Fixed</MenuItem>
          </TextField>

          <TextField
            margin="dense"
            label="Discount Value"
            name="discountValue"
            type="number"
            fullWidth
            value={formData.discountValue}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Max Discount Amount"
            name="maxDiscountAmount"
            type="number"
            fullWidth
            value={formData.maxDiscountAmount}
            onChange={handleChange}
            required
          />
          <TextField
            margin="dense"
            label="Min Order Amount"
            name="minOrderAmount"
            type="number"
            fullWidth
            value={formData.minOrderAmount}
            onChange={handleChange}
            required
          />
         <FormControl fullWidth margin="dense">
            <InputLabel>Currency</InputLabel>
            <Select name="currencyId" value={formData?.currencyId || ""} onChange={handleChange}>
              {currencies && currencies.map(c => <MenuItem key={c.currencyId} value={c.currencyId}>{c.code}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField
            margin="dense"
            label="Start Date"
            name="startDate"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={formData.startDate}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="End Date"
            name="endDate"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={formData.endDate}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Usage Limit"
            name="usageLimit"
            type="number"
            fullWidth
            value={formData.usageLimit}
            onChange={handleChange}
          />
          
          <TextField
            margin="dense"
            label="Per User Limit"
            name="perUserLimit"
            type="number"
            fullWidth
            value={formData.perUserLimit}
            onChange={handleChange}
          />
              
          <FormControlLabel
            control={
              <Switch
                checked={formData.isActive}
                onChange={(e) =>
                  setFormData({ ...formData, isActive: e.target.checked })
                }
              />
            }
            label="Active"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CouponManager;
